module.exports = __webpack_public_path__ + "static/media/vardegrund_beslutad_2016.1ca024a7.jpg";